// extracted by mini-css-extract-plugin
export default {"creditbtn":"cash_creditbtn__n1IgY","cashflx":"cash_cashflx__WxL9Q"};